import { SVGProps } from 'react'

interface ProcessIconProps extends SVGProps<SVGSVGElement> {
    isLeftIcon?: boolean // Determines if this is the left or right icon
}

const ProcessIcon = ({ isLeftIcon = true, ...props }: ProcessIconProps) => {
    return (
        <svg width='65' height='15' viewBox='0 0 65 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <rect width='65' height='15' rx='7.5' fill='#1E1E1E' fillOpacity='0.4' />
            <rect
                x='0.516796'
                y='0.516796'
                width='63.9664'
                height='13.9664'
                rx='6.9832'
                stroke='white'
                strokeOpacity='0.1'
                strokeWidth='1.03359'
                strokeDasharray='2.07 2.07'
            >
                <animate
                    attributeName='stroke-dashoffset'
                    values={isLeftIcon ? '0;10' : '10;0'}
                    dur='1s'
                    repeatCount='indefinite'
                />
            </rect>
            <circle cx='17' cy='8' r='1' fill='#D9D9D9'>
                <animate
                    attributeName='opacity'
                    values='0.3;1;0.3'
                    dur='1s'
                    begin={isLeftIcon ? '0s' : '0.5s'}
                    repeatCount='indefinite'
                />
            </circle>
            <circle cx='25' cy='8' r='1' fill='#D9D9D9'>
                <animate
                    attributeName='opacity'
                    values='0.3;1;0.3'
                    dur='1s'
                    begin={isLeftIcon ? '0.2s' : '0.7s'}
                    repeatCount='indefinite'
                />
            </circle>
            <circle cx='33' cy='8' r='1' fill='#D9D9D9'>
                <animate
                    attributeName='opacity'
                    values='0.3;1;0.3'
                    dur='1s'
                    begin={isLeftIcon ? '0.4s' : '0.9s'}
                    repeatCount='indefinite'
                />
            </circle>
            <circle cx='41' cy='8' r='1' fill='#D9D9D9'>
                <animate
                    attributeName='opacity'
                    values='0.3;1;0.3'
                    dur='1s'
                    begin={isLeftIcon ? '0.6s' : '1.1s'}
                    repeatCount='indefinite'
                />
            </circle>
            <circle cx='49' cy='8' r='1' fill='#D9D9D9'>
                <animate
                    attributeName='opacity'
                    values='0.3;1;0.3'
                    dur='1s'
                    begin={isLeftIcon ? '0.8s' : '1.3s'}
                    repeatCount='indefinite'
                />
            </circle>
        </svg>
    )
}
export default ProcessIcon
